import { useMemo } from "react";
import { useTranslation } from "@/shared/i18n";
import { PRICING_TIERS } from "@/shared/config/pricing";
import type { PlanId } from "@/shared/config/term-pricing";
import { usePlanPrices } from "../api/plan-prices-query";
import { formatPrice } from "../lib/plan-prices";

export type TranslatedPricingTier = {
  id: PlanId;
  name: string;
  icon: (typeof PRICING_TIERS)[number]["icon"];
  subtitle: string;
  description: string;
  price: string | null;
  period: string | null;
  features: string[];
};

export const usePricingTiers = (): TranslatedPricingTier[] => {
  const { t, locale } = useTranslation();
  const prices = usePlanPrices();

  return useMemo(() => {
    return PRICING_TIERS.map((tier) => {
      const cardPrice = prices.cardPrice(tier.id, "annual");
      const price = cardPrice === null ? null : formatPrice(cardPrice, locale);
      const period = cardPrice === null ? null : t("/mo (billed annually)");

      return {
        id: tier.id,
        name: tier.name,
        icon: tier.icon,
        subtitle: t(tier.subtitleKey),
        description: t(tier.descriptionKey),
        price,
        period,
        features: tier.featureKeys.map((key) => t(key)),
      };
    });
  }, [t, locale, prices]);
};
